module.exports = __webpack_public_path__ + "assets/7d36597b268782ff557faa2cc552a704.png";